module.exports = __webpack_public_path__ + "img/chinesecompany48.1477de3b.png";